import { useThemeContext } from "../globalContext/global-context";
import { formatCopy } from "../theme/copy";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, IconButton, Typography } from "@mui/material";
import type { StoredValueEntry } from "../session/transcript";

export const StoredValuesPanel = ({
  entries,
  canDelete,
  onDelete,
}: {
  entries: readonly StoredValueEntry[];
  canDelete: boolean;
  onDelete: (entry: StoredValueEntry) => void;
}) => {
  const { globalObject } = useThemeContext();
  const copy = globalObject.themeData.normalizedTheme.copy;
  return (
    <Box aria-label={copy.labels.storedValues}>
      <Typography variant="subtitle2">{copy.labels.storedValues}</Typography>
      {entries.map((entry) => (
        <Box
          key={`${entry.snapshotId}:${entry.responseIndex}`}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <IconButton
            aria-label={formatCopy(copy.actions.deleteStoredValue, {
              question: entry.question,
            })}
            disabled={!canDelete}
            onClick={() => onDelete(entry)}
          >
            <DeleteIcon />
          </IconButton>
          <Typography>
            {entry.question}: {entry.response}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
